import { useState } from 'react';
import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import { topicList } from '@/mocks/topics';

const trackedTopics = topicList.slice(0, 3);

function MediaTracking() {
  const [active, setActive] = useState(0);
  const topic = trackedTopics[active];

  return (
    <section className="w-full border-y border-background-200/80 bg-background-100 px-4 py-14 md:px-8 md:py-20">
      <SectionHeading
        eyebrow="报道对比"
        title="同一件事，各家媒体怎么写的"
        desc="我们把同一节点的不同报道标题与切入角度并列出来，方便对比报道口径的差异，而不是只看单一信源。"
      />

      <div className="mt-8 inline-flex rounded-full border border-background-300 bg-background-50 p-1">
        {trackedTopics.map((item, index) => (
          <button
            key={item.slug}
            type="button"
            onClick={() => setActive(index)}
            className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors cursor-pointer ${
              active === index
                ? 'bg-primary-500 text-foreground-950'
                : 'text-foreground-700 hover:text-foreground-950'
            }`}
          >
            {item.category}热点
          </button>
        ))}
      </div>

      <div className="mt-6 rounded-lg border border-background-200/80 bg-background-50 p-5 md:p-7">
        <div className="flex flex-wrap items-center justify-between gap-3 border-b border-background-200/80 pb-4">
          <h3 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
            {topic.title}
          </h3>
          <Link
            to={`/topic/${topic.slug}`}
            className="inline-flex items-center gap-1 whitespace-nowrap text-sm text-primary-700 hover:text-primary-800"
          >
            查看完整时间线
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-5 grid grid-cols-1 gap-4 md:grid-cols-3">
          {topic.reports.map((report) => (
            <article
              key={report.title}
              className="flex h-full flex-col rounded-lg border border-background-200/80 bg-background-100 p-4"
            >
              <div className="flex items-center gap-2">
                <span className="flex h-7 w-7 items-center justify-center rounded-md bg-secondary-500 text-xs text-background-50">
                  <i className="ri-newspaper-line" />
                </span>
                <span className="text-sm font-medium text-foreground-900">{report.media}</span>
              </div>
              <h4 className="mt-3 font-heading text-sm font-bold leading-snug text-foreground-950">
                {report.title}
              </h4>
              <p className="mt-2 flex-1 text-xs leading-relaxed text-foreground-600">
                {report.angle}
              </p>
              <span className="mt-3 inline-flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-time-line" />
                {report.time}
              </span>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default MediaTracking;